import * as THREE from 'three';
import { Entity } from '../types/Entity';
import type { GameScene } from '../core/Scene';
import type { Cookie } from './Cookie';

export class CookieMonster extends Entity {
  readonly mesh: THREE.Mesh;
  private readonly rangeMesh: THREE.Mesh;
  readonly eatRadius: number;
  private bobTime: number;

  constructor(position: THREE.Vector3, eatRadius: number) {
    super();
    this.eatRadius = eatRadius;
    this.bobTime = Math.random() * Math.PI * 2;

    const bodyGeo = new THREE.SphereGeometry(0.4, 8, 8);
    const bodyMat = new THREE.MeshLambertMaterial({ color: 0x1a7ae8 });
    this.mesh = new THREE.Mesh(bodyGeo, bodyMat);
    this.mesh.position.set(position.x, 0.4, position.z);

    const ringGeo = new THREE.RingGeometry(eatRadius - 0.06, eatRadius, 48);
    ringGeo.rotateX(-Math.PI / 2);
    const ringMat = new THREE.MeshBasicMaterial({
      color: 0x4488ff,
      transparent: true,
      opacity: 0.3,
      side: THREE.DoubleSide,
    });
    this.rangeMesh = new THREE.Mesh(ringGeo, ringMat);
    this.rangeMesh.position.set(position.x, 0.01, position.z);
  }

  canEat(cookie: Cookie): boolean {
    const dx = cookie.position.x - this.mesh.position.x;
    const dz = cookie.position.z - this.mesh.position.z;
    return dx * dx + dz * dz <= this.eatRadius * this.eatRadius;
  }

  update(delta: number): void {
    this.bobTime += delta * 2.5;
    this.mesh.position.y = 0.4 + Math.sin(this.bobTime) * 0.1;
  }

  addToScene(scene: GameScene): void {
    scene.add(this.mesh);
    scene.add(this.rangeMesh);
  }

  removeFromScene(scene: GameScene): void {
    scene.remove(this.mesh);
    scene.remove(this.rangeMesh);
  }

  dispose(): void {
    (this.mesh.geometry as THREE.BufferGeometry).dispose();
    (this.mesh.material as THREE.Material).dispose();
    (this.rangeMesh.geometry as THREE.BufferGeometry).dispose();
    (this.rangeMesh.material as THREE.Material).dispose();
  }
}
